module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[57]56.02085b2.woff2";